import { Link } from '@tanstack/react-router';
import { useCommonContent } from '../content/sections/common.js';
import { useNavContent } from '../content/sections/nav.js';
import type { NavSection } from '../lib/nav.js';

interface SidebarNavProps {
  readonly sections: readonly NavSection[];
}

/* Navegação da sidebar (ADR-0700): itens agrupados em seções com heading. Item ativo = pílula
   `accent/15` + texto foreground + barra de acento animada à esquerda + ícone tingido; hover
   `accent/10`. */
export function SidebarNav({ sections }: SidebarNavProps) {
  const copy = useCommonContent().sidebarNav;
  const nav = useNavContent();
  return (
    <nav
      className="flex flex-1 flex-col gap-6 overflow-y-auto px-3 py-4"
      aria-label={copy.ariaLabel}
    >
      {sections.map((section) => (
        <div key={section.group} className="flex flex-col gap-1">
          <p className="px-3 pb-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground/60">
            {nav.groups[section.group]}
          </p>
          {section.items.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                className="group/nav relative flex items-center gap-3 rounded-lg py-2 pl-3 pr-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent/10 hover:text-foreground [&.active]:bg-accent/15 [&.active]:text-foreground"
              >
                {/* Barra indicadora de ativo — cresce (scale-y) ao ativar. */}
                <span
                  aria-hidden="true"
                  className="absolute inset-y-2 left-0 w-[3px] origin-center scale-y-0 rounded-r-full bg-primary transition-transform duration-200 group-[.active]/nav:scale-y-100"
                />
                <Icon
                  className="size-[18px] shrink-0 text-muted-foreground/70 transition-colors group-hover/nav:text-foreground/80 group-[.active]/nav:text-accent"
                  aria-hidden="true"
                />
                <span className="truncate">{nav.items[item.to]}</span>
              </Link>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
